export default __webpack_public_path__ + "static/hands-basking-897da418c24926e33c5db47bcaf06774.jpg";